import { Component, input, output } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-header',
  imports: [MatIconModule, TranslateModule],
  template: `
    <header class="m-header">
      <div class="m-header__left">
        <h1 class="m-header__title">{{ title() }}</h1>
      </div>

      @if (showSaveButton()) {
      <div class="m-header__right">
        <button type="button" class="m-header__saveBtn" (click)="save.emit()">
          <mat-icon class="m-header__saveBtnIcon">save</mat-icon>
          <span class="m-header__saveBtnText">{{ 'COMMON.SAVE' | translate }}</span>
        </button>
      </div>
      }
    </header>
  `,
  styleUrl: './header.component.scss',
})
export class HeaderComponent {
  title = input.required<string>();
  showSaveButton = input<boolean>(true);
  save = output<void>();
}
